import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UtilsPublicService } from 'src/app/services/utils-public.service';
import { ValidationService } from 'src/app/services/validation.service';
import { Entrant } from 'src/interfaces/entrants/entrant';
import { PageBlockFormQuestion } from 'src/interfaces/pages/pageBlockFormQuestion';
import { Question } from 'src/interfaces/questions/question';

@Component({
    selector: 'app-page-block-form-question-slide-toggle',
    templateUrl: './page-block-form-question-slide-toggle.component.html',
    styleUrls: ['./page-block-form-question-slide-toggle.component.scss']
})
export class PageBlockFormQuestionSlideToggleComponent implements OnInit, OnDestroy, PageBlockFormQuestion {

    @Input() formGroup!: FormGroup;
    @Input() question!: Question;
    @Input() entrant?: Entrant;

    controlName: string = this.question?.key;
    control: FormControl = this.formBuilder?.control('', []);

    options: Question['options']['typeSpecificOptions']
    checked: boolean = false;

    constructor(private formBuilder: FormBuilder, public Validation: ValidationService, public UtilsPublic: UtilsPublicService) {
    }

    ngOnInit(): void {
        this.controlName = this.question.key;
        this.options = this.question.options.typeSpecificOptions;
        this.checked = !!(this.options && this.options.defaultChecked);
        this.setValidation();
        this.Validation.setCustomValidation(this.question, this.question.options.validations, this.control);
        this.setBranding();
    }

    get onValue() {
        return this.question.options.values && this.question.options.values[0];
    }

    get offValue() {
        return this.question.options.values && this.question.options.values[1];
    }

    toggle(checked: boolean): void {
        this.checked = checked;
        this.control.markAsDirty();
        this.control.setValue(checked ? this.onValue?.value : this.offValue?.value);
    }

    setValidation(): void {
        this.formGroup.addControl(this.controlName, this.control);

        setTimeout(() => {
            if (this.entrant && this.entrant?.answers && this.question.key in this.entrant.answers) {
                const answer = this.entrant.answers[this.question.key];
                this.checked = answer === this.onValue?.value;
                this.control.setValue(answer);
            } else {
                this.toggle(this.checked);
            }
        }, 250);
    }

    setBranding(): void {
        if (this.options && this.options.colour) {
            const css = `
                .key-${this.question.key} .mat-slide-toggle.mat-checked .mat-slide-toggle-bar {
                    background-color: ${this.options.colour};
                }
                .key-${this.question.key} .mat-slide-toggle.mat-checked .mat-slide-toggle-thumb {
                    background-color: ${this.options.colour};
                }
            `;
            this.UtilsPublic.loadCSSInline(css, this.question.key + '-slide-toggle-colour');
        }
    }

    ngOnDestroy(): void {
        this.formGroup.removeControl(this.controlName);
        this.UtilsPublic.loadCSSInline('', this.question.key + '-slide-toggle-colour');
    }
}
